/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {SendVerificationEmailModel} from "../../models/send-verification-email-model";

export interface SendVerificationEmailParams {
    body?: SendVerificationEmailModel
}

export function sendVerificationEmailPost(http: HttpClient, rootUrl: string, params: SendVerificationEmailParams, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, sendVerificationEmailPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<void>;
        })
    );
}

sendVerificationEmailPost.PATH = '/api/v1/email-verification/send-email';
